'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';

import { getNotifications } from '../../apis/notification/menu';
import type { GetNotificationsOption } from '../../types/notification';

type InfiniteNotificationsType = {
  key: any[];
  options: GetNotificationsOption;
};

export const useInfiniteNotifications = ({ key, options }: InfiniteNotificationsType) => {
  const { user, isAuthenticated } = useAuth();

  return useInfiniteQuery(
    key,
    async ({ pageParam = 1 }) =>
      await getNotifications(user?.access_token as string, { ...options, pageNumber: pageParam }),
    {
      getNextPageParam: (lastPage) => (lastPage.data.hasNext ? lastPage.data.currentPage + 1 : undefined),
      enabled: isAuthenticated,
    },
  );
};
